// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loader_overlay__p4KwS","spinner":"Loader_spinner__1YSPU"};